import React from "react";
import { Box, ButtonBase, Typography } from "@mui/material";
import { PINBIKER_HEADER_HEIGHT } from "./PinbikerHeader";

export const RAIL_WIDTH = 84;

/**
 * Barra scura a sinistra delle pagine stile UGO Web Board (pagina del pinbiker e pannello condiviso),
 * sotto l'header fisso. Solo da computer: su telefono le pagine mettono le schede in alto o niente.
 * `items`: [{ key, label, icon }], la voce attiva prende il colore `accent` del marchio.
 */
export default function SideRail({ items, active, accent, onSelect }) {
    return (
        <Box component="nav" sx={{
            display: { xs: "none", md: "flex" }, flexDirection: "column", alignItems: "center", gap: 1,
            position: "fixed", top: PINBIKER_HEADER_HEIGHT, bottom: 0, left: 0, width: RAIL_WIDTH,
            bgcolor: "#141414", pt: 1.5, zIndex: 1000,
        }}>
            {items.map(item => {
                const on = item.key === active;
                return (
                    <ButtonBase key={item.key} onClick={() => onSelect && onSelect(item.key)} sx={{
                        width: 68, py: 1, borderRadius: "10px", flexDirection: "column", gap: 0.5,
                        color: on ? "#fff" : "#9ca3af", bgcolor: on ? accent : "transparent",
                        "&:hover": { bgcolor: on ? accent : "rgba(255,255,255,.08)" },
                    }}>
                        {item.icon}
                        <Typography sx={{ fontSize: 11, lineHeight: 1.2, textAlign: "center", px: 0.5 }}>{item.label}</Typography>
                    </ButtonBase>
                );
            })}
        </Box>
    );
}
